import Link from 'next/link'
import React, { useState } from 'react'
import styled from 'styled-components'
import { HeaderLink } from './HeaderLink'
import css from '@styled-system/css'
import Stack from '@careguide/stack'

export type DropDownLink = {
  link: string
  title: string
  isExternal?: boolean
  isNextLink?: boolean
  navigationItems?: DropDownLink[]
}

export type DropdownLinkProps = {
  primaryLink: DropDownLink
}

const DropdownLink = ({ primaryLink }: DropdownLinkProps) => {
  const childLinks = primaryLink.navigationItems
  // @ts-ignore
  const hasChildLinks = childLinks?.length > 0
  const [isOpen, setIsOpen] = useState(false)

  return (
    <DropdownContainer
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onClick={() => setIsOpen(false)}
    >
      {primaryLink.isNextLink ? (
        <Link href={primaryLink.link} passHref={true}>
          <DropdownButton isExpanded={isOpen}>{primaryLink.title}</DropdownButton>
        </Link>
      ) : (
        <DropdownButton href={primaryLink.link} isExpanded={false}>
          {primaryLink.title}
        </DropdownButton>
      )}

      {hasChildLinks && isOpen && (
        <DropdownPopover>
          {childLinks!.map((item, index) => (
            <li key={index}>
              <Link href={item.link} passHref={true}>
                <HeaderLink>{item.title}</HeaderLink>
              </Link>
            </li>
          ))}
        </DropdownPopover>
      )}
    </DropdownContainer>
  )
}

export default DropdownLink

const DropdownContainer = styled.div`
  position: relative;
`

export const DropdownButton = styled(HeaderLink)<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  box-sizing: border-box;
  cursor: pointer;
  min-width: fit-content;

  ${css({
    textDecoration: 'none',
    fontSize: 1,
    fontWeight: 'regular',
    color: 'gray.6',
    bg: 'white',
    paddingY: '12px',
    border: 'none',
    borderTop: '3px solid white',
    borderBottom: '3px solid white',
    img: {
      paddingX: 1,
    },
  })};
  border-bottom-color: ${(props) => (props.isExpanded ? props.theme.colors.primary[600] : 'white')};
`

export const DropdownPopover = styled(Stack)`
  min-width: 160px;
  width: fit-content;
  position: absolute;
  outline: none;
  border: none;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  list-style: none;
  overflow: scroll;
  max-height: calc(100vh - 200px);

  ${css({
    bg: 'white',
    paddingY: 2,
    a: {
      display: 'inline-block',
      boxSizing: 'border-box',
      paddingX: 4,
      paddingY: 3,
      fontSize: 0,
    },
  })};
`
